export default __webpack_public_path__ + "static/media/dog6.b2a8edad.png";